import {combineReducers} from 'redux'
import {userReducer} from "./userReducer";
import {initialDataReducer} from "./initialDataReducer";
import {appHeaderReducer} from "./appHeaderReducer";
import {benAdminReducer} from "./benAdminReducer";
import {toastReducer} from "./toastReducer";

export const RESET_REDUX_ACTION = "RESET_REDUX_ACTION";

const appReducer = combineReducers({
    appHeader: appHeaderReducer,
    benAdmin: benAdminReducer,
    initialData: initialDataReducer,
    toast: toastReducer,
    user: userReducer,
})

const rootReducer = (state, action) => {
    if (action.type === RESET_REDUX_ACTION) {
        state = undefined
    }

    return appReducer(state, action);
};

export default rootReducer;
